export const basicData = {
  companyName: 'zebra.to Sp. z o.o.',
  addressLines: ['Dane adresowe 1', 'Dane adresowe 2'],
  contact: {
    email: 'kontakt@zebra.to',
    phone: '123-456-789',
  },
  domain: 'zebra.to',
  logoVertical: {
    component: 'LogoIcon',
    alt: 'zebra.to - logo',
  },
}
